import { CommandResult, Person, PersonType } from '../amorg-common'
import { apiPath } from "./adminClientApi";
import { commandAuthWrapper, queryAuthWrapper } from "./serverApiHelpers";

const personsPath = `${apiPath}/persons`;

export const createPerson = async (
    id:string,
    type: PersonType,
    name:string,
    role:string,
    email:string,
    phone:string
): Promise<CommandResult> =>
    commandAuthWrapper(`${personsPath}`, 'POST',
        { id, type, name, role, email, phone });

export const updatePerson = async (
    personId: string,
    name: string,
    role: string,
    email: string,
    phone: string,
    
): Promise<CommandResult> =>
    commandAuthWrapper(`${personsPath}/${personId}`, 'PUT',
        { name, role, email, phone });

export const deletePerson = async (
    personId: string
): Promise<CommandResult> =>
    commandAuthWrapper(`${personsPath}/${personId}`, 'DELETE');

export const getPerson = async (id: string): Promise<Person> =>
    queryAuthWrapper(`${personsPath}/${id}`);

export const getPersons = async (): Promise<Person[]> =>
{
    const result:Person[] = await queryAuthWrapper(`${personsPath}`);
        
    return result;
}